import { useFaireDirectFirstOrderIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";

import { usePromoModalStore } from "./PromoModalStoreImpl";

export const useShouldNotShowFaireDirectIncentiveModals = () => {
  const { hasIncentive: hasFaireDirectFirstOrderIncentive } =
    useFaireDirectFirstOrderIncentive();
  const { hasIncentive: hasFaireDirectMarketplaceIncentive } =
    useFaireDirectMarketplaceIncentive();

  const { modalToDisplay } = usePromoModalStore(["modalToDisplay"]);

  const shouldNotShowFaireDirectFirstOrderIncentiveModal =
    modalToDisplay === "FAIRE_DIRECT_INCENTIVE_MODAL" &&
    !hasFaireDirectFirstOrderIncentive;

  const shouldNotShowFaireDirectMarketplaceIncentiveModal =
    (modalToDisplay === "FAIRE_DIRECT_MARKETPLACE_DISCOUNT_MODAL" ||
      modalToDisplay === "FAIRE_DIRECT_EVERGREEN_MARKETPLACE_DISCOUNT_MODAL") &&
    !hasFaireDirectMarketplaceIncentive;

  return (
    shouldNotShowFaireDirectFirstOrderIncentiveModal ||
    shouldNotShowFaireDirectMarketplaceIncentiveModal
  );
};
